document.addEventListener('DOMContentLoaded', () => {
    const topbar = document.querySelector('#topbar');
    if (!topbar) return;

    const mediaQuery = window.matchMedia('(min-width: 1341px)');
    const threshold = 10;

    let lastScroll = window.scrollY;
    let ticking = false;

    const show = () => {
        topbar.classList.remove(
            '-translate-y-full',
            'opacity-0',
            'pointer-events-none'
        );
        topbar.classList.add(
            'translate-y-0',
            'opacity-100'
        );
    };

    const hide = () => {
        topbar.classList.remove(
            'translate-y-0',
            'opacity-100'
        );
        topbar.classList.add(
            '-translate-y-full',
            'opacity-0',
            'pointer-events-none'
        );
    };

    const update = () => {
        ticking = false;

        const currentScroll = window.scrollY;

        // Góra strony
        if (currentScroll <= 10) {
            show();
            lastScroll = currentScroll;
            return;
        }

        const diff = currentScroll - lastScroll;

        if (Math.abs(diff) > threshold) {
            diff > 0 ? hide() : show();
            lastScroll = currentScroll;
        }
    };

    const onScroll = () => {
        if (ticking) return;

        ticking = true;
        requestAnimationFrame(update);
    };

    const enable = () => {
        lastScroll = window.scrollY;

        window.addEventListener('scroll', onScroll, {
            passive: true
        });

        update();
    };

    const disable = () => {
        window.removeEventListener('scroll', onScroll);

        // Na mobile/tablet topbar zawsze widoczny
        show();

        lastScroll = window.scrollY;
        ticking = false;
    };

    const handleBreakpoint = (event) => {
        if (event.matches) {
            enable();
        } else {
            disable();
        }
    };

    // Stan początkowy
    handleBreakpoint(mediaQuery);

    // Reagujemy tylko na zmianę breakpointu,
    // a nie na każdy resize
    mediaQuery.addEventListener('change', handleBreakpoint);
});